import styled from "styled-components";

export const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	gap: 32px;
	margin-top: 24px;
`;

export const Title = styled.h1`
	font-size: 20px;
	font-weight: 700;
	line-height: 23px;
	color: #31475a !important;
`;

export const InputLine = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 32px;
`;

export const FullWidthSelectContainer = styled.div`
	width: 100%;

	select {
		width: 100%;
	}
`;

export const TextAreaInput = styled.textarea`
	width: 100%;
	height: 100px;
	border: 1px solid #31475a;
	border-radius: 6px;
	padding: 12px;
	resize: none;
	font-size: 14px;

	&::placeholder {
		color: #9f9fa9;
	}

	&:focus {
		outline: none;
	}
`;

export const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Label = styled.label`
	font-size: 14px;
	color: #000;
	line-height: 23px;
	margin-bottom: 0;
`;

export const FileUploadContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FileUploadButton = styled.label`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 8px 32px;
	border: 1px solid #534b99;
	border-radius: 6px;
	background-color: #ffffff;
	cursor: pointer;
	font-weight: 700;
	font-size: 16px;
	color: #534b99;
	width: fit-content;
`;

export const HiddenFileInput = styled.input`
	display: none;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	gap: 8px;

	button:first-child {
		background: transparent;
		border: 1px solid #504c9a;
		padding: 8px 32px;
		color: #504c9a;
		font-size: 16px;
		line-height: 23px;
		font-weight: bold;
	}

	button:last-child {
		background: #504c9a;
		border: 1px solid #504c9a;
		padding: 8px 32px;
		color: #fff;
		font-size: 16px;
		line-height: 23px;
		font-weight: bold;
	}

	button {
		border-radius: 8px;

		&:disabled {
			background: #f2f4f7;
			border: 1px solid #f2f4f7;
			color: #dddddd;
			cursor: not-allowed;
		}
	}
`;
